module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"being-processed":"Em processamento...","face-not-persisted":"As faces estão em processamento. Por favor aguarde.","try-again":"Tentar novamente"}}')
  delete Component.options._Ctor
}
